import { useEffect, useState } from 'react';

const useKeyModRerender = (checked) => {
  const [keyMod, setKeyMod] = useState(0);
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    if (checked !== isChecked) {
      setIsChecked(checked);
      setKeyMod(keyMod + 1);
    }
  }, [checked]);
  return keyMod;
};

export default useKeyModRerender;
